export const communicationKinds = {
  message: 'message',
  file: 'file',
  order: 'order',
  request: 'request',
  read: 'read',
  resync: 'resync'
} as const;
export type CommunicationKind = typeof communicationKinds[keyof typeof communicationKinds];
export interface MessageAttachment {
  id: string;
  fileName: string;
  contentType: string;
  sizeInBytes: number;
  dateAdded: string;
  isImage: boolean;
}
export interface OrderMessage {
  id: string;
  senderName: string;
  fromClient: boolean;
  isMine: boolean;
  body: string;
  createdAt: string;
  attachments?: MessageAttachment[];
  hasUnavailableAttachments?: boolean;
}
export interface MessagePage {
  items: OrderMessage[];
  hasMore: boolean;
  clientId?: string;
}
export interface AppNotification {
  id: string;
  kind: CommunicationKind;
  title: string;
  createdAt: string;
  isRead: boolean;
  orderId?: string;
  fileId?: string;
  orderNumber?: string;
}
export interface NotificationSummary {
  unreadCount: number;
  unreadMessageCounts: Record<string, number>;
}
export interface NotificationPage extends NotificationSummary {
  items: AppNotification[];
  hasMore: boolean;
  totalCount: number;
  currentPage: number;
}
export interface CommunicationChange {
  orderId?: string;
  kind: CommunicationKind;
}
export function notificationOrderTab(notification: AppNotification): 'details' | 'communication' | 'files' {
  if (notification.kind === communicationKinds.message)
    return 'communication';
  return notification.kind === communicationKinds.file ? 'files' : 'details';
}

export function notificationOrderQueryParams(notification: AppNotification) {
  return {
    search: notification.orderNumber ?? null,
    expandId: notification.orderId,
    tab: notificationOrderTab(notification)
  };
}
